import { useEffect, useState } from 'react';

import { getCampaignEventTypes, getCampaignEventsCount } from 'services/MailingService';
import { getLiteral } from 'utils/getLiteral';

const normalizeCountTotal = (total) => {
    const parsedTotal = Number(total);
    return Number.isFinite(parsedTotal) ? Math.max(0, Math.trunc(parsedTotal)) : 0;
};

const loadCounts = async (campaignId, types) => {
    const results = await Promise.all(
        types.map((type) =>
            getCampaignEventsCount(campaignId, type.type).catch(() => ({ total: 0 })),
        ),
    );

    return types.reduce((acc, type, index) => {
        acc[type.type] = normalizeCountTotal(results[index]?.total);
        return acc;
    }, {});
};

export const useCampaignRecipientsCounts = ({ campaignId, isActive }) => {
    const [eventTypes, setEventTypes] = useState([]);
    const [activeType, setActiveType] = useState(null);
    const [countsByType, setCountsByType] = useState({});
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [loadingCounts, setLoadingCounts] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isActive || campaignId == null || campaignId === '') {
            return undefined;
        }

        let cancelled = false;
        setLoadingTypes(true);
        setLoadingCounts(true);
        setError(null);
        setEventTypes([]);
        setActiveType(null);
        setCountsByType({});

        (async () => {
            try {
                const types = await getCampaignEventTypes(campaignId);
                if (cancelled) return;

                setEventTypes(types);
                setActiveType(types[0]?.type ?? null);

                const counts = await loadCounts(campaignId, types);
                if (cancelled) return;
                setCountsByType(counts);
            } catch {
                if (!cancelled) {
                    setError(getLiteral('label_no_data'));
                }
            } finally {
                if (!cancelled) {
                    setLoadingTypes(false);
                    setLoadingCounts(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [isActive, campaignId]);

    return {
        eventTypes,
        activeType,
        setActiveType,
        countsByType,
        loadingTypes,
        loadingCounts,
        error,
    };
};
